import { useEffect, useState } from "react";
import "survey-core/defaultV2.min.css";

import { Model } from "survey-core";
import { Survey } from "survey-react-ui";
import useAppConfig from "../../hooks/useAppConfig";
import { Box, Skeleton } from "@mui/material";

export default function SurveyForm({ initialValues = {},onCompleting , isEdit = false }) {
  const [survey, setSurvey] = useState();
  const [surveyStepperLoader, setSurveyStepperLoader] = useState(0);
  const pwaConfig = useAppConfig();

  useEffect(() => {
    const enrollmentFormCreatorModel =
      pwaConfig.appConfig?.config?.enrollmentForm;
    const questionConfig = pwaConfig.appConfig?.config?.questionConfig;

    if (!enrollmentFormCreatorModel) return;
    const filteredModel = JSON.parse(JSON.stringify(enrollmentFormCreatorModel));
    filteredModel.pages.forEach((page) => {
      if (page.elements) {
        page.elements = page.elements.map((element) => {
          if (element.name === "mobile") {
            element.readOnly = true;
          }
          return element;
        });
      }
    })
    if (isEdit) {
    filteredModel.title = "Edit Profile";
    filteredModel.description = "Let us know if anything has changed";
      filteredModel.pages.forEach((page) => {
        if (page.elements) {
          page.elements = page.elements.filter((element) => {
            const config = questionConfig?.[element.name] || {
              allowUpdate: "false",
              hideInUpdate: "false",
            };
            if (config.hideInUpdate === "true") {
              return false;
            }
         
            element.readOnly = true;
            if (config.allowUpdate === "true") {
              element.readOnly = false;
            }
            if (element.name === "mobile") {
              element.readOnly = true;
            }
            return true;
          });
        }
      });
    }
    const tempModel = new Model(filteredModel);
    const today = new Date().toISOString().split("T")[0];

    const dobQuestion = tempModel.getQuestionByName("dob");
    if (dobQuestion) {
        dobQuestion.max = today;
    }

    const anniversaryQuestion = tempModel.getQuestionByName("anniversary");
    if (anniversaryQuestion) {
      anniversaryQuestion.max = today;
    }
 
    tempModel.focusFirstQuestionAutomatic = false;
    tempModel.completeText = isEdit ? "Update" : "Submit";
    if (initialValues && Object.keys(initialValues).length > 0) {
      tempModel.data = initialValues;
    }
    const primaryColor =
      filteredModel?.theme?.cssVariables?.[
        "--sjs-primary-backcolor"
      ] ?? "#1976d2";
    tempModel.completedHtml = `
      <div style="text-align:center; font-size:1.2rem; color:${primaryColor}">
        Profile Successfully Updated 
      </div>
    `;
    if (typeof tempModel.applyTheme === "function" && filteredModel?.theme) {
      tempModel.applyTheme(filteredModel?.theme);
    }
    tempModel.onOpenDropdownMenu.add((_, options) => {
      options.menuType = "dropdown";
    });
    tempModel.onCompleting.add((sender, options) => {
      options.allowComplete = true;
      onCompleting(sender.data)
    });

    setSurvey(tempModel);
    setSurveyStepperLoader(2);
  }, [pwaConfig.appConfig?.config?.enrollmentForm, initialValues,onCompleting,isEdit,pwaConfig.appConfig?.config?.questionConfig]);

  if (surveyStepperLoader < 2) {
    return (
      <Box sx={{ p: 2 }}>
        <Skeleton variant="text" width="60%" height={40} />
        <Skeleton variant="rectangular" height={200} sx={{ mt: 2 }} />
        <Skeleton variant="text" width="40%" height={40} sx={{ mt: 2 }} />
      </Box>
    );
  }

  return <Survey model={survey} />;
}
